import { Modal } from "antd"
import { useDeleteTaxRate } from "@mimber/client/mimber-organization"
import { message } from "@mimber/ui-web"
import type { OrganizationTaxRateDto } from "@mimber/schema"

/**
 * Hook-based confirm modal for deleting an organization tax rate.
 * The server rejects deletion with a 400 if the rate is still assigned to a
 * revenue type — that message is surfaced as-is via the error toast.
 */
export const useDeleteTaxRateModal = (onSuccess?: () => void) => {
  const [modal, contextHolder] = Modal.useModal()
  const deleteMutation = useDeleteTaxRate()

  const showDeleteTaxRateModal = (taxRate: OrganizationTaxRateDto): void => {
    modal.confirm({
      title: "Delete Tax Rate",
      content: `Are you sure you want to delete "${taxRate.name}"? This action cannot be undone.`,
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () =>
        new Promise<void>((resolve, reject) => {
          deleteMutation.mutate(taxRate.uuid, {
            onSuccess: () => {
              message.success("Tax rate deleted")
              onSuccess?.()
              resolve()
            },
            onError: (error) => {
              message.error(`Failed to delete tax rate: ${error.message}`)
              reject()
            },
          })
        }),
    })
  }

  return {
    contextHolder,
    showDeleteTaxRateModal,
  }
}
